import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useNavigate } from 'react-router-dom';
import { Team } from "types";
export const DeleteTeam = ({ children, team }: { children: React.ReactNode, team: Team }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const [userSpTeamName, setUserSpTeamName] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(true);
    useEffect(() => {
        const teamNameStr = String(userSpTeamName);
        if (teamNameStr.length === 0) {
            setButtonDisabled(true);
        } else if (teamNameStr !== team.name) {
            setButtonDisabled(true);
        } else {
            setButtonDisabled(false);
        }
    }, [userSpTeamName]);
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger className="w-full">
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 ">
                <DialogHeader className="items-center justify-center">
                    <DialogTitle>
                        Delete Team
                    </DialogTitle>
                    <DialogDescription>
                        Are you sure you want to delete this team? This action is irreversible.
                    </DialogDescription>
                </DialogHeader>
                <Label>
                    Type {team.name} to confirm:
                </Label>
                <Input
                    className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                    placeholder="Team Name"
                    type="text"
                    autoComplete="false"
                    onChange={(e) => { setUserSpTeamName(e.target.value) }}
                />
                <div className="flex items-center justify-center mt-2">
                    <Button className="bg-brand-green px-5 py-2 w-full rounded-lg text-white font-semibold hover:bg-green-500 disabled:bg-opacity-50" disabled={buttonDisabled} onClick={async () => {
                        await fetch(`__SITE_BASE__/api/teams`, { method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                id: team.id
                            })
                         });
                        navigate('/');
                    }}>
                        Delete
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );

};